<template>
  <div class="login_container" align="center">
    <el-form :rules="rules" ref="form" :model="form" label-position="right" label-width="120px">
      <el-form-item prop="mobile_phone" label="手机号码">
        <el-input type="text" maxlength="11" v-model="form.mobile_phone" placeholder="请输入手机号码"></el-input>
      </el-form-item>

      <el-form-item prop="captcha" label="验证码">
        <el-input style="width: 80%;" type="text" maxlength="6" v-model="form.captcha" placeholder="请输入验证码"></el-input>
        <el-button style="width: 19%;" :type="canClickSendCodeBtn?'':'primary'" plain :disabled="canClickSendCodeBtn"
                   @click="onSendSMS">{{sendCodeTip}}
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-button style="width: 100%;" type="success" plain :disabled="canClickLogin" @click="onSubmit">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

  import {APIRequest} from '@/api/api';
  import {setMember} from '@/utils/auth';

  export default {
    data() {
      return {
        sms_tid: '',                     // 短信TID
        sms_type: '',
        codeNumber: '',                  // 验证码
        sendCodeTip: '获取验证码',        // 发送验证码提示
        canClickSendCodeBtn: false,      // 是否可以点击发送验证码按钮
        canClickLogin: false,            // 是否可以点击登录按钮

        form: {
          mobile_phone: "",
          captcha: ""
        },
        rules: {
          mobile_phone: [
            {required: true, message: '手机号码不能为空', trigger: 'blur'},
            {regexp: '^1(3|4|5|6|7|8|9)[0-9]\d{8}$^', message: '手机号码格式错误', trigger: 'blur'}
          ],
          captcha: [
            {required: true, message: '验证码不能为空', trigger: 'blur'},
            {type: 'string', length: 4, message: '长度为4个字符', trigger: 'blur'}
          ]
        },
      }
    },

    methods: {
      onSubmit() {
        let self = this;
        this.$refs.form.validate(valid => {
          if (valid) {
            if (self.sms_tid === '' || self.sms_type === '') {
              self.$message.error('请先获取验证码');
              return;
            }
            // 构建请求参数
            let params = {};
            params.mobile_phone = self.form.mobile_phone.trim();
            params.captcha = self.form.captcha.trim();
            params.sms_tid = self.sms_tid;
            params.sms_type = self.sms_type;
            // 短信登录
            APIRequest('smsLogin', params, false).then(res => {
              // 解析会员信息并且存储
              let member = res.data.member;
              let token = res.data.token;
              member.token = token;
              setMember(member);
              // 判断是否更新会员信息
              if (res.data.need_update_user_info === true) {
                // 首次登录，跳转到用户数据更新页面
              } else {
                self.$router.push({path: '/'});
              }
            }, err => {});
          } else {
            return false;
          }
        })
      },
      onSendSMS() {
        let self = this;
        let mobile_phone = this.form.mobile_phone;
        if (mobile_phone.length === 11) {
          let phoneReg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
          if (!(phoneReg.test(mobile_phone))) {
            self.canClickSendCodeBtn = false;
            self.$message.error('请输入正确的手机号码');
            return;
          } else {
            self.canClickSendCodeBtn = true;
          }
        } else {
          self.canClickSendCodeBtn = false;
          self.$message.error('请输入正确的手机号码');
          return;
        }

        let count = 60;
        let timer = setInterval(function () {
          if (count <= 0) {
            clearInterval(timer);
            self.canClickSendCodeBtn = false;
            self.sendCodeTip = '获取验证码';
          } else {
            self.sendCodeTip = count + 's' + '重新获取';
          }
          count--;
        }, 1000);

        let params = {};
        params.type = 2; // 注册验证码，使用type = 2
        params.mobile_phone = mobile_phone;
        APIRequest('send_sms', params, false).then(res => {
          self.sms_tid = res.data.sms_tid;
          self.sms_type = res.data.sms_type;
          this.$message({
            message: '发送短信成功',
            type: 'success'
          });
        }, error => {
        });
      }
    }

  }
</script>

<style>

  .login_container {
    width: 800px;
    margin: 100px auto 150px auto;
  }

</style>




// WEBPACK FOOTER //
// src/components/Member/Login.vue